module.exports = __webpack_public_path__ + "img/bank-note-03.be2adb52.svg";